<template>
<div>

    <Preloader plain v-show="!initializationDone" />

    <div v-if="initializationDone" class="main-content">

      <div v-if="!currentTokenInfo || !currentTokenInfo.name" class="content-box p-3 text-center shadow-box-light">
        {{ $t('instantBuyTokenPage.tokenNotFound') }}
       </div>

      <div v-else>

        <div class="mb-4 mx-3 body-2" v-html="$t('instantBuyTokenPage.introTxt')">
        </div>

        <div v-if="!tokenAvailableToBuy" class="text-center px-4">
          <v-btn disabled>{{ $t('instantBuyTokenPage.notAvailableForInstant')}}</v-btn>
        </div>

        <div v-else class="text-center px-4">
          <v-btn color="primary" v-on:click="renderInstant()">{{ $t('instantBuyTokenPage.btnTxtBuy') }}</v-btn>
        </div>

      </div>

    </div>

</div>
</template>

<script>
import { config } from '@/config'
import { assetDataUtils} from '@0x/order-utils'
import {mapActions, mapGetters, mapState} from 'vuex'
import OrderSummary from "@/components/OrderSummary"
import BackButton from "@/components/BackButton"
import { searchTokenByAddress } from '@/utils/TokenUtils'
import { loadExternalScript } from '@/utils/utils'
import Preloader from "@/components/Preloader"
import { HttpClient } from '@0x/connect'
import { AssetProxyId } from '@0x/types'
import Vue from 'vue'

export default {
  name: 'ZeroExInstant',
  components: {
    Preloader,
  },
  props: {
    tokenAddress: { type: String, required: true },
  },
  data () {
    return {
      config: config,
      orderSourceList: [],
      selectedOrderSource: null,
      tokenAvailableToBuy: false,
      currentTokenInfo: {},
      initializationDone: false,
      showForm: false,
    }
  },
  computed: {
    ...mapGetters({
      network: 'getNetwork',
      account: 'getAccount',
      tokenInfo: 'getTokenInfo',
      networkConfig: 'getNetworkConfig',
    }),
    etherScanTokenURL: function () {
      return this.config.network[this.network.id].tokenURL
    }
  },

  methods: {
    ...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'getTokenInfoByAddress']),

    /* ------------------------------------------------------ */
    async init () {
      this.initializationDone = false
      this.showForm = false

      const scriptURL = this.config.zeroExInstantScriptURL
      await loadExternalScript(scriptURL)
      await this.loadNetwork()
      await this.loadTokenInfo()
      this.currentTokenInfo = await this.getTokenInfoByAddress(this.tokenAddress)
      // console.log(this.currentTokenInfo)
      this.orderSourceList = [ ...this.networkConfig.relayers ]
      await this.checkTokenLiquidity()
      this.initializationDone = true
    },

    async renderInstant () {

      if (!this.currentTokenInfo.assetData || !this.selectedOrderSource.apiURL) {
        return
      }

      const assetData = this.currentTokenInfo.assetData
      // console.log(assetData)

      const assetMeta = {}
      assetMeta[assetData] = {
        assetProxyId: this.currentTokenInfo.assetProxyId,
        decimals: this.currentTokenInfo.decimals,
        symbol: this.currentTokenInfo.symbol,
        name: this.currentTokenInfo.name,
      }

      console.log(this.selectedOrderSource.apiURL)

      this.showForm = true

      zeroExInstant.render(
        {
          networkId: this.network.id,
          chainId: this.network.id,
          orderSource: this.selectedOrderSource.apiURL,
          availableAssetDatas: [assetData],
          defaultSelectedAssetData: assetData,
          additionalAssetMetaDataMap: assetMeta,
          onSuccess: this.onSuccess,
        }, 'body'
      )

    },

    async checkTokenLiquidity () {

      if (!this.currentTokenInfo.name) {
        return
      }

      this.currentTokenInfo.assetData = assetDataUtils.encodeERC20AssetData(this.currentTokenInfo.address)
      this.currentTokenInfo.assetProxyId = AssetProxyId.ERC20

      const searchOptions = {
        baseAssetData: assetDataUtils.encodeERC20AssetData(this.currentTokenInfo.address),
        quoteAssetData: assetDataUtils.encodeERC20AssetData(this.tokenInfo.WETHToken.address)
      }

      const tasks = []
      for (let relayer of this.orderSourceList) {
        tasks.push(this.loadRelayerOrders (relayer, searchOptions))
      }

      await Promise.all(tasks)
      // console.log(this.orderSourceList)

      let maxNoOrders = 0
      for (let relayer of this.orderSourceList) {
        if (relayer.totalOrders && relayer.totalOrders > maxNoOrders) {
          this.selectedOrderSource = relayer
          this.tokenAvailableToBuy = true
          maxNoOrders = relayer.totalOrders
        }
      }

    },

    async loadRelayerOrders (relayer, searchOptions) {
      const relayerApiURL = relayer.apiURL
      const httpClient = new HttpClient(relayerApiURL)
      try {
        const orderBook = await httpClient.getOrderbookAsync(
          searchOptions
        )
        console.log(relayer.name.charAt(0) + ' Instant: ' + orderBook.asks.total + ' asks, ' + orderBook.bids.total + ' bids' )
        relayer.totalOrders = orderBook.asks.total
      } catch (err) {
        console.log(err)
        relayer.totalOrders = 0
      }
    },

    onClose () {

    },

    async onSuccess (txHash) {
      console.log('Instant Buy Success: ' + txHash)
      await this.loadAccount(true)
      this.$emit("zero-ex-instant-success", txHash)
    },

    async refresh () {
      this.selectedOrderSource = null
      this.tokenAvailableToBuy = false
      this.currentTokenInfo = {}
      this.initializationDone = false
      this.init();
    },

  },
  created () {
    // this.$emit('hide-sidebar')
    this.init()
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
